import { Grid, Stack, Typography } from '@mui/material'
import {FC} from 'react'
import { Draggable, Droppable } from '../../../../../../../../components/Drag&Drop'
import { IGrantPipelineStage } from '../../../../../../../../types'
import { KanbanViewCard } from './KanbanViewCard'

interface KanbanViewColumnsProps {
  pipelineStages: IGrantPipelineStage[]
  pipelineData: Record<string, { pfs: any[]; totalAmount: number }>
}

export const KanbanViewColumns: FC<KanbanViewColumnsProps> = ({ pipelineData, pipelineStages }) => {

  return (
    <Grid container justifyContent="space-between" gap={0.5}>
      {pipelineData && pipelineStages.map(({ index, stage, textColor, backgroundColor }) => {
        const pfs = pipelineData[stage]?.pfs || []

        return <Grid
          key={index}
          item
          md={2.35}
          sm={6}
          xs={12}
          sx={{ background: backgroundColor, borderRadius: '10px', p: 1 }}
        >
          <Stack mb={1.5} gap={0.2}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '0.9rem',
                color: textColor,
                textTransform: 'capitalize',
              }}
            >
              {stage}
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '1rem',
                color: "black",
              }}
            >
              {`${pfs.length} ($${pipelineData[stage]?.totalAmount.toLocaleString('en-US') || 0})`}
            </Typography>

          </Stack>

          <Droppable id={stage} droppableSx={{ height: `calc(100% - 44px)` }}>
            {pfs.map((pf: any) => {
              const {
                taxYear,
                matchedPFId,
                progressStatus,
                organizationName,
                formattedCharityAmount
              } = pf

              return (
                progressStatus === stage && (
                  <Draggable id={matchedPFId} key={matchedPFId} data={{ matchedPFId }}>
                    <KanbanViewCard
                      taxYear={taxYear}
                      title={organizationName}
                      amount={formattedCharityAmount}
                    />
                  </Draggable>
                )
              )
            })}
          </Droppable>
        </Grid>
      })}
    </Grid>
  )
}
